import React from 'react';
import { useTranslation } from 'react-i18next';
import whatsapp from './whatsapp.png';
import email from './email.png';

const PHONE_DISPLAY = '+34 631 01 91 08';
const PHONE_WA = '34631019108';
const EMAIL_ADDR = 'marcinjarzebiak59@gmail.com';
const ADDRESS = '5 Carrer Cervantes , Crevillente, Spain';

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="site-footer" id="contact">
      <div className="site-footer-inner">
        <h1 className="site-footer-title">{t('contact')}</h1>

        <div className="site-footer-grid">
          <a
            className="site-footer-item"
            href={`https://wa.me/${PHONE_WA}`}
            target="_blank"
            rel="noreferrer"
          >
            <img src={whatsapp} alt="WhatsApp" />
            <div className="site-footer-item-text">{PHONE_DISPLAY}</div>
          </a>

          <a className="site-footer-item" href={`mailto:${EMAIL_ADDR}`}>
            <img src={email} alt="Email" />
            <div className="site-footer-item-text">{EMAIL_ADDR}</div>
          </a>

          <div className="site-footer-item site-footer-item--static">
            <img src={email} alt="Address" />
            <div className="site-footer-item-text">{ADDRESS}</div>
          </div>
        </div>

        <div className="site-footer-bottom">
          <span>© {new Date().getFullYear()} Detailing</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

